import { DropdownGroupFactory } from './DropdownGroupFactory';
import { InputDataTypeMaxMinFactory } from './InputDataTypeMaxMinFactory';
import { EventTypeInputRatingFactory } from './EventTypeInputRatingFactory';
import { EventTypeInput } from '../types/ViewModel/EventTypeInput';
import { DropdownGroup } from '../types/ViewModel/DropdownGroup';
import { InputDataTypeMaxMin } from '../types/ViewModel/InputDataTypeMaxMin';
import { InputDataTypeEnum } from '../enums/inputDataTypeEnum';
import { EventTypeInputRating } from '../types/ViewModel/EventTypeInputRating';
import { EventTypeInputBM } from '../types/BusinessModel/EventTypeInputBM';
import EventTypeInputRegFactory from './EventTypeInputRegFactory';
import { EventTypeInputReg } from '../types/ViewModel/EventTypeInputReg';

export default () => {
    const dropdownGroupFactory = new DropdownGroupFactory();
    const inputDataTypeMaxMinFactory = new InputDataTypeMaxMinFactory();
    const eventTypeInputRatingFactory = new EventTypeInputRatingFactory();
    const { createNewEventTypeInputReg } = EventTypeInputRegFactory();

    const newEventTypeInput = (eventTypeInput: EventTypeInputBM): EventTypeInput => {
        return new EventTypeInput(
            eventTypeInput.eventTypeInputId,
            eventTypeInput.eventTypeId,
            eventTypeInput.inputDataType,
            eventTypeInput.inputHeading,
            eventTypeInput.mandatory,
            eventTypeInput.mandatory,
            eventTypeInput.dropdownGroup ? dropdownGroupFactory.newDropdownGroup(eventTypeInput.dropdownGroup, eventTypeInput.mandatory) : null,
            eventTypeInput.inputDataTypeMaxMin ? inputDataTypeMaxMinFactory.newInputDataTypeMaxMin(eventTypeInput.inputDataTypeMaxMin) : null,
            eventTypeInput.inputOrder,
            eventTypeInput.deleted,
            eventTypeInput.eventTypeInputRating ? eventTypeInputRatingFactory.newEventTypeInputRating(eventTypeInput.eventTypeInputRating) : null,
            null,
            true,
            false
        );
    };

    const createNewEventTypeInputArray = (evTypeInpArray: EventTypeInput[] | null): EventTypeInput[] => {
        const eventTypeInputArray: EventTypeInput[] = [];
        if (evTypeInpArray && evTypeInpArray.length > 0) {
            evTypeInpArray.map((etig) => {
                const item = createEventTypeInput(etig);
                if (item) {
                    eventTypeInputArray.push(item);
                }
            });
            return eventTypeInputArray.sort((eti) => eti.inputOrder);
        }
        return eventTypeInputArray;
    };

    const createEventTypeInput = (evTypeInp: EventTypeInput): EventTypeInput => {
        return new EventTypeInput(
            evTypeInp.eventTypeInputId,
            evTypeInp.eventTypeId,
            evTypeInp.inputDataTypeId,
            evTypeInp.inputHeading,
            evTypeInp.mandatory,
            evTypeInp.inputMandatory,
            evTypeInp.dropdownGroup
                ? dropdownGroupFactory.newDropdownGroupFromCode(
                      evTypeInp.dropdownGroup.dropdownGroupId,
                      evTypeInp.dropdownGroup.eventInputDropdownGroupId,
                      evTypeInp.dropdownGroup.description,
                      evTypeInp.dropdownGroup.multiple,
                      evTypeInp.dropdownGroup.dropdownTypeId,
                      evTypeInp.dropdownGroup.dropdownItemArray,
                      evTypeInp.dropdownGroup.required,
                      evTypeInp.dropdownGroup.disabled,
                      evTypeInp.dropdownGroup.disabledItemName
                  )
                : null,
            inputDataTypeMaxMinFactory.createInputDataTypeMaxMin(evTypeInp.inputDataTypeMaxMin),
            evTypeInp.inputOrder,
            evTypeInp.deleted,
            eventTypeInputRatingFactory.createEventTypeInputRating(evTypeInp.eventTypeInputRating),
            evTypeInp.eventTypeInputReg ? createNewEventTypeInputReg(evTypeInp.eventTypeInputReg) : null,
            evTypeInp.isEmpty,
            evTypeInp.isValid
        );
    };

    const newEventTypeInputFromCode = (
        eventTypeInputId: number,
        eventTypeId: number,
        inputDataType: InputDataTypeEnum,
        inputHeading: string,
        mandatory: boolean,
        inputMandatory: boolean,
        dropdownGroup: DropdownGroup,
        inputDataTypeMaxMin: InputDataTypeMaxMin,
        inputOrder: number,
        deleted: boolean,
        eventTypeInputRating: EventTypeInputRating,
        eventTypeInputReg: EventTypeInputReg,
        isEmpty: boolean,
        isValid: boolean
    ): EventTypeInput => {
        return new EventTypeInput(
            eventTypeInputId,
            eventTypeId,
            inputDataType,
            inputHeading,
            mandatory,
            inputMandatory,
            dropdownGroup
                ? dropdownGroupFactory.newDropdownGroupFromCode(
                      dropdownGroup.dropdownGroupId,
                      dropdownGroup.eventInputDropdownGroupId,
                      dropdownGroup.description,
                      dropdownGroup.multiple,
                      dropdownGroup.dropdownTypeId,
                      dropdownGroup.dropdownItemArray,
                      dropdownGroup.required,
                      dropdownGroup.disabled,
                      dropdownGroup.disabledItemName
                  )
                : null,
            inputDataTypeMaxMinFactory.createInputDataTypeMaxMin(inputDataTypeMaxMin),
            inputOrder,
            deleted,
            eventTypeInputRatingFactory.createEventTypeInputRating(eventTypeInputRating),
            createNewEventTypeInputReg(eventTypeInputReg),
            isEmpty,
            isValid
        );
    };

    return {
        newEventTypeInput,
        createNewEventTypeInputArray,
        createEventTypeInput,
        newEventTypeInputFromCode,
    };
};
